/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg-set-orange[_ngcontent-%COMP%]{background-color:#fab034!important}.bg-set-black[_ngcontent-%COMP%]{background-color:#231f20!important}.text-orange[_ngcontent-%COMP%]{color:#fab034!important}.label-gray[_ngcontent-%COMP%]{font-size:16px;background-color:rgba(0,0,0,.05);color:#231f20;padding-left:.25rem;padding-right:.25rem;border-radius:.25rem;border:1px solid #dee2e6}"];
export { styles as styles };
